export interface DigitalFemsaIframeConfig {
  options: any;
  config: IframeConfig;
  callbacks: IframeCallbacks;
  digitalFemsaSource?: string;
  isIntegration?: boolean;
}

interface IframeConfig {
  locale: string;
  targetIFrame: string;
  allowTokenization: true;
  checkoutRequestId: string; // checkout request id
  publicKey: string;
}

interface IframeCallbacks {
  onCreateTokenSucceeded: Function;
  onCreateTokenError: Function;
  onFinalizePayment: Function;
  onErrorPayment: Function;
  onGetInfoSuccess: Function;
}

export enum DigitalFemsaSource {
  EMBEDDED = 'checkout-embedded',
  PAYMENT_LINK = 'payment-link',
  REDIRECTED = 'checkout-redirect',
  COMPONENT = 'component',
}

export const xSource = 'x-source';
